package pwgs.ui.scenes.login

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.ds.components.Button
import visage.ds.components.Modal

class MLoginScene(props: LoginSceneProps) : AScene<LoginSceneProps, LoginSceneModel, LoginSceneState, LoginControllerFe>(props) {

    override fun createController() : LoginControllerFe {
        return LoginControllerFe(props, this)
    }

    override fun initState() : LoginSceneState {
        return LoginSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MLoginScene.model
        if (m.loginUrl == null) {
            Modal("Sign in") {
                Button("Sign in with Google") {
                    onClick = this@MLoginScene.controller::handleLoginClicked
                }
            }
        } else {

        }
    }
}

class LoginSceneState {

}

fun Components.LoginScene(props: LoginSceneProps) = this.registerComponent(MLoginScene(props), {})
